// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"78":"ea90599e","556":"a0af4adb","740":"5fa16577","901":"42f3f9a2","960":"f3771679"}[chunkId] + ".css";
};